import type { ShellSlice } from '../bs/shell'

/**
 * Croatian overrides for the application frame.
 *
 * A short list, and that is the point — most of this frame is word-for-word
 * shared. What moves: *sustav* for system, *tvrtka* for firm, *poslužitelj* for
 * server, *račun* for account, *spremiti* for save, and *što* where Bosnian
 * writes *šta*.
 *
 * The plural keys are absent because Croatian shares the Bosnian three-form
 * rule *and* the nouns — "prijava / prijave / prijava" declines identically, so
 * overriding them would repeat the base three times over.
 */
export const shell: Partial<ShellSlice> = {
  'theme.system': 'Prema sustavu',

  'nav.owner.hint': 'Sve tvrtke i podrška',

  'account.myAccount': 'Moj račun',
  'account.ariaLabel': 'Račun — {name}',

  'queue.savedOnDevice': 'Prijave se spremaju na uređaj.',
  'queue.hint': 'Prijave se šalju automatski. Ovdje možete provjeriti što je ostalo.',
  'queue.offlineNotice':
    'Trenutno nema veze s poslužiteljem. Prijave su spremljene na uređaju i bit će poslane čim se veza vrati — možete zatvoriti aplikaciju.',
  'queue.discardConfirm':
    'Ukloniti ovu prijavu iz reda čekanja? Neće biti poslana i podaci se gube.',

  'nav.guide': 'Upute',

  'module.disabled.title': 'Ovaj modul nije uključen za vašu tvrtku.',
  'module.disabled.description':
    '„{module}“ trenutačno nije dio vaše aplikacije. Podaci su spremljeni — ako vam ovaj dio treba, obratite se svom administratoru.',
}
